import { render, staticRenderFns } from "./jobRiskPop.vue?vue&type=template&id=556b1d94"
import script from "./jobRiskPop.vue?vue&type=script&lang=js"
export * from "./jobRiskPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('556b1d94')) {
      api.createRecord('556b1d94', component.options)
    } else {
      api.reload('556b1d94', component.options)
    }
    module.hot.accept("./jobRiskPop.vue?vue&type=template&id=556b1d94", function () {
      api.rerender('556b1d94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/mss/jobRiskPop.vue"
export default component.exports